export const NameRegex = /^[a-zA-Z][-'a-zA-Z_._ )-]+\s[a-zA-Z][a-zA-Z _.-_ ]{0,19}$/;

export const PasswordRegex = /^(?=.*\d)(?=.*[A-Za-z])(?!.*\s).{8,20}$/;

export const EmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const HtmlTagsRegex = /(<([^>]+)>)/ig;

/**
 * Password regex rule:
 * 1. 1 lower case
 * 2. 1 upper case
 * 3. 1 digit
 * 4. support of special chars
 * 5. no spaces
 * 6. min of 8 chars
 * 7. max of 10 chars
 * */

/**
 *  Name regex rule:
 *  1. at least two words:
 *    a. word : is any 1 char with space between it and another
 *        Ryan H - valid
 *        Ryan Hoffman - valid
 *        Ryan-Moshe Hoffman - valid
 *   b. Not case sensitive
 *          ryan Hoffman - valid
 * 2. Support consecutive space
 *     Ryan        Hoffman - valid
 *
 * 3. Support for . and , chars (for job prefix)
 *    Dr. Ryan Hoffman - Valid
 *    Ryan Jr. Hoffman - valid
 *    Dr. Hoffman - valid
 *
 *
 * 3. 20 characters at most for each word !!!
 *
 * */
